webpackJsonp([0],{

/***/ "2Oe+":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "42Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("DK6z");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213614bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("R6Nm");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_213614bc_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Cz8s":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__ = __webpack_require__("wqBJ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40572016_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__ = __webpack_require__("g/bw");
function injectStyle (ssrContext) {
  __webpack_require__("wJsV")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40572016"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40572016_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "DK6z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__("mzkE");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "index",
  components: {
    HeaderMain: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */],
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__footer__["a" /* default */]
  },
  data: function data() {
    return {
      currentMenuType: "index" //当前页面
    };
  }
});

/***/ }),

/***/ "HCTz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header",
  props: ["menuType"],
  data: function data() {
    return {
      stock: "股票代码 600763  5H"
    };
  },

  methods: {
    banner: function banner() {
      var t,
          sp = 2,
          limit;
      var $bannerItems = $("#J_BannerItems"),
          $bannerItem = $(".J_BannerItem"),
          $bannerBtn = $(".J_BannerBtn");

      limit = $bannerItem.length + 1;

      //实现分页点动态居中的js处理
      if ($bannerBtn.length) {
        var $pointsElWidth = parseInt($bannerBtn.css("width")) / 2;
        $bannerBtn.css("margin-left", -$pointsElWidth);
      }

      //实现图片渐变切换
      var getData = function getData(page) {
        $.each($bannerItem, function (i, n) {
          if (i + 1 == page) {
            $(this).siblings().fadeOut(400);
            $(this).fadeIn(400);
          }
        });
      };

      //实现页码切换
      var switchCss = function switchCss($obj) {
        $obj.siblings().removeClass("selected");
        $obj.addClass("selected");
      };

      //分页mouseenter和mouseleave事件处理
      $bannerBtn.delegate("p", "mouseenter", function () {
        var $this = $(this);
        switchCss($this);
        getData(parseInt($this.attr("data-num")));

        clearInterval(t);
      });

      $bannerBtn.delegate("p", "mouseleave", function () {
        var $this = $(this);
        sp = parseInt($this.attr("data-num")) + 1;
        if (sp == limit) {
          sp = 1;
        }
        autoSwitch();
      });

      //图片mouseenter和mouseleave事件处理
      $bannerItems.delegate(".J_BannerItem", "mouseenter", function () {
        clearInterval(t);
      });

      $bannerItems.delegate(".J_BannerItem", "mouseleave", function () {
        var $this = $(this);
        sp = parseInt($this.attr("data-page")) + 1;
        if (sp == limit) {
          sp = 1;
        }
        autoSwitch();
      });

      var autoSwitch = function autoSwitch() {
        t = setInterval(function () {
          $.each($bannerBtn.find("p"), function (i, n) {
            if (parseInt($(n).attr("data-num")) == sp) {
              switchCss($(n));
            }
          });
          getData(sp);
          sp = sp + 1;
          if (sp == limit) {
            sp = 1;
          }
        }, 5000);
      };

      //启动自动切换模式
      autoSwitch();
    }
  },
  mounted: function mounted() {
    this.banner();
  },
  computed: {
    menuType1Selected: function menuType1Selected() {
      return this.menuType == "index";
    },
    menuType2Selected: function menuType2Selected() {
      return this.menuType == "about";
    }
  }
});

/***/ }),

/***/ "HMG6":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191c2dad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("VyH3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_191c2dad_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__("YaEn");
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.




__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */] }
});

/***/ }),

/***/ "R6Nm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderMain',{attrs:{"menuType":_vm.currentMenuType}}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('FooterMain')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"index-container"},[_c('div',{staticClass:"index-box-01"},[_c('div',{staticClass:"index-box-01-main"},[_c('div',{staticClass:"index-box-01-box"},[_c('div',{staticClass:"index-box-01-title"},[_c('i',{staticClass:"right"},[_c('img',{attrs:{"src":__webpack_require__("2Oe+")}})]),_vm._v(" "),_c('span',[_c('h1',[_vm._v("集团简介")]),_vm._v(" "),_c('h2',[_vm._v("Management team")])])])]),_vm._v(" "),_c('div',{staticClass:"index-box-01-box"},[_c('div',{staticClass:"index-box-01-img1"},[_c('img',{attrs:{"src":__webpack_require__("fY0S")}}),_vm._v(" "),_c('p',[_vm._v("\n              三个苹果引进国外最先进的生产设备，所产青汁产品畅销美国、加拿大、欧洲、亚洲等二十多个国家和地区。\n              是可口可乐、百事可乐、柯林斯等世界顶级企业的果汁原料供\n              应商，产品生产通过192多道物理压榨、检测、\n              分离工艺，拒绝任何添加剂，保证产品绝对纯正天然。\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"clear"})])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TVmP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__ = __webpack_require__("UthT");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d69324_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__ = __webpack_require__("rtCu");
function injectStyle (ssrContext) {
  __webpack_require__("lNHE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b8d69324"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8d69324_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "UthT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "footer",
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "VyH3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"min-width":"1020px"},attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YaEn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("7+uW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Header__ = __webpack_require__("teIl");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Footer__ = __webpack_require__("TVmP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Index__ = __webpack_require__("42Hy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_About__ = __webpack_require__("c27y");







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/header',
    name: 'Header',
    component: __WEBPACK_IMPORTED_MODULE_2__components_Header__["a" /* default */]
  }, {
    path: '/footer',
    name: 'Footer',
    component: __WEBPACK_IMPORTED_MODULE_3__components_Footer__["a" /* default */]
  }, {
    path: '/',
    name: 'Index',
    component: __WEBPACK_IMPORTED_MODULE_4__components_Index__["a" /* default */]
  }, {
    path: '/about',
    name: 'About',
    component: __WEBPACK_IMPORTED_MODULE_5__components_About__["a" /* default */]
  }]
}));

/***/ }),

/***/ "Zs8U":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__header__ = __webpack_require__("Cz8s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__footer__ = __webpack_require__("mzkE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_about_building_png__ = __webpack_require__("HMG6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__assets_about_building_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__assets_about_building_png__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



 //导入地图上的建筑图标
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "about",
  components: {
    HeaderMain: __WEBPACK_IMPORTED_MODULE_0__header__["a" /* default */],
    FooterMain: __WEBPACK_IMPORTED_MODULE_1__footer__["a" /* default */]
  },
  data: function data() {
    return {
      currentMenuType: "about",
      address: "地址：陕西省西安市雁塔区高新四路高科广场A座804",
      tel: "电话：029-89583911",
      code: "邮编：710000"
    };
  },

  methods: {
    map: function map() {
      var map = new BMap.Map("M_map");
      var poi = new BMap.Point(108.900539, 34.242465);
      var content = "<div style='margin:0;line-height:25px;padding:2px;'>" + this.address + "<br/>" + this.tel + "<br/>" + this.code;
      "</div>";
      var myIcon = new BMap.Icon(__WEBPACK_IMPORTED_MODULE_2__assets_about_building_png___default.a, new BMap.Size(143, 175));
      var marker = new BMap.Marker(poi, { icon: myIcon });
      map.centerAndZoom(poi, 19);
      map.enableScrollWheelZoom();
      map.addOverlay(marker);
      //创建检索信息窗口对象
      var searchInfoWindow = null;
      searchInfoWindow = new BMapLib.SearchInfoWindow(map, content, {
        title: "三个苹果", //标题
        width: 290, //宽度
        height: 105, //高度
        panel: "panel", //检索结果面板
        enableAutoPan: true, //自动平移
        searchTypes: [BMAPLIB_TAB_SEARCH, //周边检索
        BMAPLIB_TAB_TO_HERE, //到这里去
        BMAPLIB_TAB_FROM_HERE //从这里出发
        ]
      });
      marker.addEventListener("click", function (e) {
        searchInfoWindow.open(marker);
      });
      searchInfoWindow.open(marker);
    }
  },
  mounted: function mounted() {
    this.map();
  }
});

/***/ }),

/***/ "c27y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__ = __webpack_require__("Zs8U");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c2dc74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__ = __webpack_require__("cr4h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_About_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61c2dc74_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_About_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "ce18":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
	name: "footer",
	data: function data() {
		return {};
	}
});

/***/ }),

/***/ "cr4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeaderMain',{attrs:{"menuType":_vm.currentMenuType}}),_vm._v(" "),_c('div',{staticClass:"about-container"},[_c('div',{staticClass:"about-info"},[_c('div',{staticClass:"left about-info-l"},[_c('p',[_vm._v(_vm._s(_vm.address))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.tel))]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.code))])]),_vm._v(" "),_vm._m(0)])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('FooterMain')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right about-info-r"},[_c('div',{staticClass:"left about-online"},[_c('img',{attrs:{"src":__webpack_require__("vMa3")}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"map",attrs:{"id":"M_map"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fY0S":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/index-box-01-img1.aff0530.jpg";

/***/ }),

/***/ "g/bw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-container"},[_c('ul',[_c('li',[_c('a',{class:_vm.menuType1Selected ? 'on' : '',attrs:{"href":"/#/"}},[_vm._v("首页")])]),_vm._v(" "),_c('li',[_c('a',{class:_vm.menuType2Selected ? 'on' : '',attrs:{"href":"/#/about"}},[_vm._v("关于我们")])])])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-logo"},[_c('a',{attrs:{"href":"/#/"}},[_c('img',{attrs:{"src":__webpack_require__("ijjk")}})])]),_vm._v(" "),_c('div',{staticClass:"clear"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"env-wrap",attrs:{"id":"J_Banner"}},[_c('div',{attrs:{"id":"J_BannerItems"}},[_c('div',{staticClass:"env env1 selected J_BannerItem",attrs:{"data-page":"1"}}),_vm._v(" "),_c('div',{staticClass:"env env2 J_BannerItem",attrs:{"data-page":"2"}}),_vm._v(" "),_c('div',{staticClass:"env env3 J_BannerItem",attrs:{"data-page":"3"}}),_vm._v(" "),_c('div',{staticClass:"env env4 J_BannerItem",attrs:{"data-page":"4"}})]),_vm._v(" "),_c('div',{staticClass:"env-nav J_BannerBtn"},[_c('p',{staticClass:"selected",attrs:{"data-num":"1"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"2"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"3"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"4"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gIsy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-main"},[_vm._v("\n\t版权所有\n\t"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n\t  陕ICP备2023002849号\n\t")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ijjk":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/toplogo.b8c9fd7.png";

/***/ }),

/***/ "lNHE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "lUlW":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mzkE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__ = __webpack_require__("ce18");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfac22e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__ = __webpack_require__("gIsy");
function injectStyle (ssrContext) {
  __webpack_require__("x4h8")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-cfac22e4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_footer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cfac22e4_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_footer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "rtCu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('div',{staticClass:"footer-main"},[_vm._v("\n\t版权所有\n\t"),_c('a',{attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("\n\t  陕ICP备2023002849号\n\t")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "teIl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__ = __webpack_require__("HCTz");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c726056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__ = __webpack_require__("vDp5");
function injectStyle (ssrContext) {
  __webpack_require__("lUlW")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-8c726056"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Header_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_8c726056_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Header_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "vDp5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"nav"},[_c('div',{staticClass:"nav-container"},[_c('ul',[_c('li',[_c('a',{class:_vm.menuType1Selected ? 'on' : '',attrs:{"href":"/#/"}},[_vm._v("首页")])]),_vm._v(" "),_c('li',[_c('a',{class:_vm.menuType2Selected ? 'on' : '',attrs:{"href":"/#/about"}},[_vm._v("关于我们")])])])])]),_vm._v(" "),_vm._m(1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"head"},[_c('div',{staticClass:"head-logo"},[_c('a',{attrs:{"href":"/#/"}},[_c('img',{attrs:{"src":__webpack_require__("ijjk")}})])]),_vm._v(" "),_c('div',{staticClass:"clear"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"banner"},[_c('div',{staticClass:"box"},[_c('div',{staticClass:"env-wrap",attrs:{"id":"J_Banner"}},[_c('div',{attrs:{"id":"J_BannerItems"}},[_c('div',{staticClass:"env env1 selected J_BannerItem",attrs:{"data-page":"1"}}),_vm._v(" "),_c('div',{staticClass:"env env2 J_BannerItem",attrs:{"data-page":"2"}}),_vm._v(" "),_c('div',{staticClass:"env env3 J_BannerItem",attrs:{"data-page":"3"}}),_vm._v(" "),_c('div',{staticClass:"env env4 J_BannerItem",attrs:{"data-page":"4"}})]),_vm._v(" "),_c('div',{staticClass:"env-nav J_BannerBtn"},[_c('p',{staticClass:"selected",attrs:{"data-num":"1"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"2"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"3"}}),_vm._v(" "),_c('p',{attrs:{"data-num":"4"}})])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vMa3":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),

/***/ "wJsV":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wqBJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "header",
  props: ["menuType"],
  data: function data() {
    return {
      stock: "股票代码 600763  5H"
    };
  },

  methods: {
    banner: function banner() {
      var t,
          sp = 2,
          limit;
      var $bannerItems = $("#J_BannerItems"),
          $bannerItem = $(".J_BannerItem"),
          $bannerBtn = $(".J_BannerBtn");

      limit = $bannerItem.length + 1;

      //实现分页点动态居中的js处理
      if ($bannerBtn.length) {
        var $pointsElWidth = parseInt($bannerBtn.css("width")) / 2;
        $bannerBtn.css("margin-left", -$pointsElWidth);
      }

      //实现图片渐变切换
      var getData = function getData(page) {
        $.each($bannerItem, function (i, n) {
          if (i + 1 == page) {
            $(this).siblings().fadeOut(400);
            $(this).fadeIn(400);
          }
        });
      };

      //实现页码切换
      var switchCss = function switchCss($obj) {
        $obj.siblings().removeClass("selected");
        $obj.addClass("selected");
      };

      //分页mouseenter和mouseleave事件处理
      $bannerBtn.delegate("p", "mouseenter", function () {
        var $this = $(this);
        switchCss($this);
        getData(parseInt($this.attr("data-num")));

        clearInterval(t);
      });

      $bannerBtn.delegate("p", "mouseleave", function () {
        var $this = $(this);
        sp = parseInt($this.attr("data-num")) + 1;
        if (sp == limit) {
          sp = 1;
        }
        autoSwitch();
      });

      //图片mouseenter和mouseleave事件处理
      $bannerItems.delegate(".J_BannerItem", "mouseenter", function () {
        clearInterval(t);
      });

      $bannerItems.delegate(".J_BannerItem", "mouseleave", function () {
        var $this = $(this);
        sp = parseInt($this.attr("data-page")) + 1;
        if (sp == limit) {
          sp = 1;
        }
        autoSwitch();
      });

      var autoSwitch = function autoSwitch() {
        t = setInterval(function () {
          $.each($bannerBtn.find("p"), function (i, n) {
            if (parseInt($(n).attr("data-num")) == sp) {
              switchCss($(n));
            }
          });
          getData(sp);
          sp = sp + 1;
          if (sp == limit) {
            sp = 1;
          }
        }, 5000);
      };

      //启动自动切换模式
      autoSwitch();
    }
  },
  mounted: function mounted() {
    this.banner();
  },
  computed: {
    menuType1Selected: function menuType1Selected() {
      return this.menuType == "index";
    },
    menuType2Selected: function menuType2Selected() {
      return this.menuType == "about";
    }
  }
});

/***/ }),

/***/ "x4h8":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'app'
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.95be6693a435e24c3a63.js